import { render, staticRenderFns } from "./VideoGreetingSlider.vue?vue&type=template&id=f6773b1a&scoped=true"
import script from "./VideoGreetingSlider.vue?vue&type=script&lang=js"
export * from "./VideoGreetingSlider.vue?vue&type=script&lang=js"
import style0 from "./VideoGreetingSlider.vue?vue&type=style&index=0&id=f6773b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6773b1a",
  null
  
)

export default component.exports